import { render } from "./Money.vue?vue&type=template&id=193dee1d&scoped=true"
import script from "./Money.vue?vue&type=script&lang=js"
export * from "./Money.vue?vue&type=script&lang=js"

import "./Money.vue?vue&type=style&index=0&id=193dee1d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193dee1d"],['__file',"src/components/h5/data/Money.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "193dee1d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('193dee1d', __exports__)) {
    api.reload('193dee1d', __exports__)
  }
  
  module.hot.accept("./Money.vue?vue&type=template&id=193dee1d&scoped=true", () => {
    api.rerender('193dee1d', render)
  })

}


export default __exports__